import { HomePage } from 'pages/homePage/HomePage';
import { NoPage } from 'pages/noPage/NoPage';
import { BASEURL } from 'context/context';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartPage } from 'pages/cartPage/CartPage';

export type IAppProps = {};

const App: React.FC<IAppProps> = ({}) => {
  const [, setUserId] = useState('');

  const createUserId = async () => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      name: 'Macky',
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    try {
      const result = await fetch(
        `${BASEURL}/addNewUser`,
        requestOptions as any,
      );
      const userIdLs = await result.text();
      localStorage.setItem('userId', userIdLs);
      setUserId(userIdLs);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const userIdLs = localStorage.getItem('userId');
    if (userIdLs) {
      setUserId(userIdLs);
    } else {
      createUserId();
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export { App };
